export const MANAGED_ELSEWHERE_MESSAGE =
  'You manage this snippet from the Careforce organization.'
export const CUSTOMIZE_LEAD = 'Editing creates your copy.'
export const CUSTOMIZE_MESSAGE =
  'After you save, your organization stops following Careforce updates for this snippet. Close without saving to keep following Careforce.'
export const OUT_OF_DATE_MESSAGE =
  'Careforce changed the original after you customized it.'
export const HIDDEN_MESSAGE =
  'Other organizations do not see it in their snippets or scripts. Their admins can still read its text in compiled prompts.'
export const VARIANT_FORK_MESSAGE =
  'Only this duty uses this wording. After you save, this duty no longer follows the primary snippet.'
